import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

// Define the shape of the context
interface StoreContextType {
  invite: InviteType | null;
  setInvite: (user: InviteType | null) => void;
}

interface InviteType {
  status: string,
  message: string,
  user_invite: {
    id: string,
    department_id: string,
    email: string,
    realm_name: string,
    locale: string,
    status: string,
    link: string,
    creation_datetime: string,
    update_datetime: string
  }
}

// Create the context with default values
const StoreContext = createContext<StoreContextType | undefined>(undefined);

// Create a provider component
const StoreProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [invite, setInvite] = useState<InviteType | null>(() => {
    const storedState = localStorage.getItem('invite');
    return storedState ? JSON.parse(storedState) : null;
  });
  
  useEffect(() => {
    localStorage.setItem('invite', JSON.stringify(invite));
  }, [invite]);
  
  return (
    <StoreContext.Provider value={{ invite, setInvite }}>
      {children}
    </StoreContext.Provider>
  );
};

// Create a custom hook to use the GlobalContext
const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useGlobal must be used within a StoreProvider');
  }
  return context;
};

export { StoreProvider, useStore };
